// extracted by mini-css-extract-plugin
export default {"root":"Notes_root__3PFk4","head":"Notes_head__db3rS","wave":"Notes_wave__nnwZb","columns":"Notes_columns__iLdGp","column":"Notes_column__15AW3","icon":"Notes_icon__qpoxN"};